import {
  Box,
  Flex,
  Icon,
  mdBumps,
  Notification,
  NotificationProps,
  PrimaryButton,
  smBumps,
  Typo,
} from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { CustomerAccount, getAccountUsablePaymentMethod } from '../../../domain'
import { useSetupMandate } from '../../../hooks/directDebit'
import { TKey, useWriskTranslation } from '../../../infrastructure/internationalisation'
import { usePaymentMethods } from '../../product/policy/billing'

export interface DirectDebitMissingNotificationProps extends NotificationProps {
  customerAccount: CustomerAccount
}

const tKey = TKey('components.direct-debit-missing-notification')

export const DirectDebitMissingNotification: FunctionComponent<
  DirectDebitMissingNotificationProps
> = ({ customerAccount, ...props }) => {
  const { t } = useWriskTranslation()

  const { paymentMethods } = usePaymentMethods()

  const onSetupMandate = useSetupMandate(customerAccount)

  const paymentMethod = getAccountUsablePaymentMethod(
    paymentMethods,
    customerAccount.paymentMethodType,
    customerAccount.accountCode,
  )

  return customerAccount.paymentMethodType && !paymentMethod ? (
    <Notification
      type='standalone'
      variant='critical'
      flexDirection={['column', 'column', 'row']}
      {...props}
    >
      <Flex
        justifyContent='flex-start'
        mr={[0, 0, 4]}
        mb={[4, 4, 0]}
        width={[1, 1, 3 / 5]}
      >
        <Icon
          icon='warning'
          size='small'
          mr={smBumps}
          display={['none', 'none', 'block']}
        />
        <Typo>{t(tKey('header'))}</Typo>
      </Flex>
      <Box width={[1, 1, 2 / 5]} pl={[0, 0, ...mdBumps.slice(2)]}>
        <PrimaryButton
          variant='critical'
          onClick={onSetupMandate.execute}
          loading={onSetupMandate.loading}
          width={1}
          whiteSpace='nowrap'
        >
          {t(tKey('actions.set-up'))}
        </PrimaryButton>
      </Box>
    </Notification>
  ) : null
}
